import $ from 'jquery/src/jquery';

export default () => {
    const nodeSelectors = {
        container: '[js-site-events="container"]',
        filter: '[js-site-events="filter"]'
    }

    function init() {
        if (!document.querySelector(nodeSelectors.container)) {
            return
        }

        initAbout()
    }

    function initAbout() {
        $(nodeSelectors.filter).on('click', function(){
            if($(this).hasClass('past')){
                $('.single-filter').removeClass('active')
                $(this).addClass('active')
                $('.events-list.upcoming').css('display', 'none');
                $('.events-list.past').css('display', 'block');
            }
            
            if($(this).hasClass('upcoming')){
                $('.single-filter').removeClass('active')
                $(this).addClass('active')
                $('.events-list.upcoming').css('display', 'block');
                $('.events-list.past').css('display', 'none');
            }
        })
    }

    return Object.freeze({
        init,
    })
}